var bs$ = require('jquery/dist/jquery');
window.Tether = require('tether');

// require bootstrap with jQuery > 1.9
require('imports?jQuery=jquery/dist/jquery!bootstrap/dist/js/bootstrap');

require('./scss/bootstrap.scss');

// bootstrap's jquery
module.exports = bs$;


//////////////////
// WEBPACK FOOTER
// ./joor_modules/helpers/bootstrap.js
// module id = 15
// module chunks = 5